var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoplarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1050 1050",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st1{fill:#27BAEF;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M564,518.32h-38.09V306.36h136.58c20.73,0,37.59,16.86,37.59,37.59c0,10.05-3.91,19.49-11.02,26.59 l-85.28,85.27l-26.93-26.93l84.42-84.42H564V518.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.17,518.32h38.09V306.36H344.68c-20.73,0-37.59,16.86-37.59,37.59c0,10.05,3.91,19.49,11.02,26.59 l85.28,85.27l26.93-26.93l-84.42-84.42h97.26V518.32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.72,739.89H111.2V589.18h49.64c13.64,0,25.39,4.75,35.27,14.24c9.95,9.49,14.93,20.89,14.93,34.2v2.05 c0,13.31-4.98,24.7-14.93,34.2c-9.87,9.42-21.63,14.13-35.27,14.13h-20.12V739.89z M157.96,659.95c6.12,0,11.2-2.01,15.26-6.04 c4.12-3.96,6.19-8.92,6.19-14.89c0-6.04-2.07-11.19-6.19-15.43c-4.12-4.24-9.21-6.36-15.26-6.36h-17.25v42.72H157.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M308.45,743.34c-23,0-42.16-7.7-57.5-23.09c-15.33-15.97-22.99-34.41-22.99-55.34 c0-14.67,3.61-27.98,10.84-39.92c6.93-12.01,16.7-21.58,29.3-28.7c12.54-7.05,25.99-10.57,40.36-10.57 c21.52,0,40.17,7.7,55.95,23.09c15.84,15.68,23.77,34.38,23.77,56.1c0,22.37-7.67,41.03-23,55.99 C349.61,735.86,330.7,743.34,308.45,743.34z M308.45,716.05c13.56,0,25.28-4.89,35.15-14.68c10.03-9.56,15.04-21.72,15.04-36.46 c0-14.1-5.01-26.25-15.04-36.46c-9.58-9.78-21.55-14.67-35.93-14.67c-14.37,0-26.31,4.89-35.82,14.67 c-9.58,9.57-14.37,21.72-14.37,36.46c0,16.83,6.23,30.13,18.68,39.92C285.52,712.31,296.28,716.05,308.45,716.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M439.79,739.89h-29.52V589.18h49.64c13.64,0,25.39,4.75,35.27,14.24c9.95,9.49,14.93,20.89,14.93,34.2v2.05 c0,13.31-4.98,24.7-14.93,34.2c-9.87,9.42-21.63,14.13-35.27,14.13h-20.12V739.89z M457.03,659.95c6.12,0,11.2-2.01,15.26-6.04 c4.12-3.96,6.19-8.92,6.19-14.89c0-6.04-2.07-11.19-6.19-15.43c-4.12-4.24-9.21-6.36-15.26-6.36h-17.25v42.72H457.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M603.98,739.89h-71.76V589.18h28.63v123.31h43.12V739.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M774.8,739.89h-30.96l-11.5-30.85h-63.13l-12.94,30.85h-30.18l59.59-150.71h29.52l0.66,2.16l-15.04,37.86 l-20.89,51.78h41.69l-10.07-24.49l15.14-37.87L774.8,739.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M895.97,740.11h-31.5l-28.09-51.24h-10.06v51.24h-29.41V590.15h49.53c13.56,0,25.24,4.71,35.04,14.13 c9.66,9.42,14.48,20.82,14.48,34.2v1.4c0,20.28-10.02,35.24-30.07,44.88L895.97,740.11z M843.56,660.92 c5.75,0,10.8-2.16,15.14-6.47c4.28-4.17,6.42-9.28,6.42-15.32c0-5.97-2.14-10.93-6.42-14.89c-4.2-4.02-9.25-6.04-15.14-6.04 h-17.25v42.72H843.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M907.88,591.33h-6.25v-2.61h15.34v2.61h-6.28v16.48h-2.81V591.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M920.5,588.72h2.81l6.7,12.48l6.7-12.48h2.81v19.09h-2.81v-13.59l-6.7,12.48l-6.7-12.48v13.59h-2.81V588.72z "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoplarLogo);
export default __webpack_public_path__ + "static/media/poplar-logo.c97400bc4cb592fdd7c13378b76bd9e4.svg";
export { ForwardRef as ReactComponent };